import { Text, Stack } from '@mantine/core';
import { IconChevronLeft } from '@tabler/icons-react';
import { DataTableColumn } from 'mantine-datatable';
import { ProviderSource } from '../types';
import { SimpleTable } from 'src/common/components/table/SimpleTable';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { formatDate } from 'src/financial/financial-data/tables/FinancialItemGenericTable';
import { useSidebarMenu } from 'src/UI/page-nav/MenuTriggerSlot';

const VALUATIONS_PROVIDER_DISPLAY_MAP: Record<string, string> = {
  ORIGO: 'Origo',
  FINIO: 'FINIO',
};

const normalizeValuationsProvider = (provider: string | null): string => {
  if (!provider) return 'Manually added';
  return VALUATIONS_PROVIDER_DISPLAY_MAP[provider] || provider;
};

export default function ProvidersListPage() {
  const { open, isCollapsed } = useSidebarMenu({ customTrigger: true });

  const columns: DataTableColumn<ProviderSource>[] = [
    {
      accessor: 'provider',
      title: 'Provider',
      sortable: true,
      render: (ps: ProviderSource) => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {ps.provider}
        </Text>
      ),
    },
    {
      accessor: 'valuationsProvider',
      title: 'Data source',
      sortable: true,
      render: (ps: ProviderSource) => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {normalizeValuationsProvider(ps.valuationsProvider)}
        </Text>
      ),
    },
    {
      accessor: 'lastUpdateDate',
      title: 'Last update',
      sortable: true,
      render: (ps: ProviderSource) => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {ps.lastUpdateDate ? formatDate(ps.lastUpdateDate) : 'N/A'}
        </Text>
      ),
    },
    {
      accessor: 'count',
      title: 'Count',
      sortable: true,
      render: (ps: ProviderSource) => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {ps.count}
        </Text>
      ),
    },
  ];

  return (
    <Stack gap="md">
      <SimpleTable<ProviderSource>
        title="Active providers"
        titleIcon={
          isCollapsed ? (
            <IconChevronLeft size={20} color="var(--mantine-color-gray-8)" />
          ) : undefined
        }
        onTitleClick={isCollapsed ? open : undefined}
        resource="provider-sources/existing"
        columns={columns}
        pageSize={20}
        showCount
        useLocalPagination
      />
      <SimpleTable<ProviderSource>
        title="Unmatched providers"
        resource="provider-sources/unprocessed"
        columns={columns}
        pageSize={20}
        showCount
        useLocalPagination
      />
    </Stack>
  );
}
